<template>
  <div class="treebox">
    <el-tree
      ref="defaultSearchTree"
      :default-expand-all="true"
      :data="searchResult"
      :props="defaultProps"
      node-key="id"
      :highlight-current="true"
      @node-click="handleNodeClick"
    >
    </el-tree>
  </div>
</template>

<script>
import {
  booksTree,
} from "@/api/api"
export default {
  name: "booksTree",
  data () {
    return {
      defaultProps: {
        children: "children",
        label: "name",
      },
      searchResult: [],
      books: [],//用于下一种上一种
      activebookIndex: -1,//用于下一种上一种
    }
  },
  mounted () {

    this.getbooksTree()
    //上一种下一种
    this.$bus.$on('nextBook', (params) => {
      this.nextBook(params)
    })
  },
  methods: {
    nextBook (params) {
      if (this.activebookIndex == -1) {
        console.log(params, this.books, 'iiiparams')
        for (let i = 0; i < this.books.length; i++) {
          if (params.bookId == this.books[i].realId) {
            console.log(i, 'iiiparams')
            this.activebookIndex = i
            break
          }
        }

      }
      if (params.type == 2) {

        if (this.activebookIndex >= this.books.length) {
          this.activebookIndex = this.books.length
          this.$message.warning("已到最後一本書了")
        } else {
          this.activebookIndex += 1
        }
      } else if (params.type == 1) {

        if (this.activebookIndex <= 0) {
          this.activebookIndex = 0
          this.$message.warning("已到第一本書了")
        } else {
          this.activebookIndex -= 1
        }
      }
      this.$nextTick(
        function () {
          this.$router.push({
            name: 'viewer',
            query: {
              bookId: this.books[this.activebookIndex].realId,
              bookName: this.books[this.activebookIndex].name,
            },
          })
          // window.location.reload()
          this.$router.go(0)
        }
      )




    },
    // 获取所有书目
    getAllBooks (arr, books = []) {

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].nodeType == "book"
        ) { books.push(arr[i]) }
        else if (arr[i].nodeType == "category" && arr[i].children.length > 0) {
          this.getAllBooks(arr[i].children, books)
        }

      }
      // console.log(books, 'books')
      return books
    },

    getbooksTree () {
      // getHitCount({
      //   hitCountType: 2
      // }).then((data) => {

      //   console.log(this.searchResult, 'this.searchResult')
      // })
      booksTree({
        parentId: 0,
        nodeType: 'category'
      }).then((data) => {
        // console.log(data)
        this.searchResult = data.data
        this.books = this.getAllBooks(data.data, [])

      })
    },
    handleNodeClick (data) {
      console.log(data)
      if (data.nodeType == "book") {
        const url = this.$router.resolve("/bookDetail?id=" + data.realId)
        window.open(url.href)
      }

    }
  },


}
</script>

<style>
.treebox {
  width: 100%;
  height: 95%;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/bookstree.vue